import { RestoreCompanyUseCase } from 'shared/domain/company/types/useCases';
import {
  HttpRequestModelType,
  HttpRequestStatus,
} from 'shared/domain/httpRequest/httpRequestModel';
import { add as addRequest } from 'serviceWorker/db/httpRequests';
import { debugLog } from 'shared/logger/debugLog';
import { CompanyHttpRestoreRequestModel } from '../httpQueue/company/types';

export class CompanyRestorer implements RestoreCompanyUseCase {
  constructor(
    private addRequest: (
      request: CompanyHttpRestoreRequestModel
    ) => Promise<any>
  ) {}
  async execute({
    companyId,
    uniqueId,
    projectId,
  }: {
    companyId: string;
    uniqueId: string;
    projectId: string;
  }): Promise<void> {
    debugLog('RestoreCompanyUseCase', companyId);

    const request: CompanyHttpRestoreRequestModel = {
      createdAt: Date.now(),
      method: 'GET',
      data: {
        companyId: companyId,
        projectId,
        uniqueId: uniqueId,
      },
      url: `/project/${projectId}/company/${companyId}`,
      entityType: HttpRequestModelType.company,
      status: HttpRequestStatus.NEW,
    };
    await this.addRequest(request);
  }
}

export const companyRestorer = new CompanyRestorer(addRequest);
